import React from 'react';
import { useSpring, animated } from '@react-spring/web';

function NumberAnimated({n}){
    const {number} = useSpring({
      from : {number : 0},
      number: n,
      delay: 100,
      config: {mass: 1, tension: 20, friction:10, duration: 1000},
    });
    return <animated.div>{number.to((n)=> n.toFixed(0))}</animated.div>
  }

export default NumberAnimated;
